import { NonFunctionProperties } from "@/Common/Models/NonFunctionProperties";
import { CareElementFrequencyType } from "../CareElementFrequencyType";
import { CareElementOperatorType } from "../CareElementOperatorType";
import { BaseCareElementConfig } from "./BaseCareElementConfig";
import { CareElementType } from "./CareElementType";

export class ReviewedCareElementConfig extends BaseCareElementConfig {
    public Name: string;
    public CareElementType: CareElementType;
    public Target?: boolean | number | Date | Set<string> | null;
    public SubSectionName?: string;
    public Frequency?: CareElementFrequencyType;
    public Operator?: CareElementOperatorType;

    public constructor(init?: NonFunctionProperties<ReviewedCareElementConfig>) {
        super(init);
        this.Name = init?.Name ?? "";
        this.Target = init?.Target ?? null;
        this.SubSectionName = init?.SubSectionName ?? "";
        this.Frequency = init?.Frequency ?? null;
        this.Operator = init?.Operator ?? null;
    }
}
